<template>
  <v-layout>
    <v-flex>
      <v-row no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            @doRefresh="doRefresh"
            @doSavePrint="doSavePrint"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Update Invoice
          <v-spacer></v-spacer>
          <InvoiceStatus :status="invoice.status" :statuses="statuses"></InvoiceStatus>
        </v-card-title>
        <v-card-subtitle>
          #{{invoice.invoice_no}}
          <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-card-text class="text--primary mt-6">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="invoice.bill_to_name"
                    label="Bill To"
                    hide-details
                    outlined
                  ></v-text-field>


                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="invoice.bill_to_contact_no"
                    label="Contact No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="invoice.bill_to_address"
                    label="Address"
                    auto-grow
                    rows="1"
                    outlined
                    hide-details
                  ></v-textarea>
                </v-col>

              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="5" offset-md="2">
              <v-row>
                <v-col cols="12">
                  <v-menu
                      v-model="menuCreatedDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="invoice.invoice_date"
                          label="Invoice Date"
                          append-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="invoice.invoice_date"
                        @input="menuCreatedDate = false"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-menu
                      v-model="menuDueDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="invoice.due_date"
                          label="Due Date"
                          append-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="invoice.due_date"
                        @input="menuDueDate = false"
                        :min="new Date().toISOString().substr(0, 10)"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="invoice.ref_no"
                    label="Reference No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-card-title class="text-h6 mt-10 mr-0 pr-0">
            <v-spacer></v-spacer>
            <v-btn
              class="ml-md-10"
              large
              depressed
              color="primary"
              @click="showForInvoice()"
            >
              <v-icon dark class="mr-2">
                mdi-note-plus-outline
              </v-icon>
              Add Item For Invoice
            </v-btn>
          </v-card-title>

          <v-sheet
            rounded
            class="pa-5 px-6 pb-7"
            color="#f3f3f3">

            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              class="item-data-input"
              :items-per-page="1000"
              hide-default-footer
              loading-text="Loading Items..."
              no-data-text="No Items"
              ref="table">

              <template v-slot:item.description="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.description"
                  placeholder="Description"
                  :append-icon="getShipmentIcon(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.qty="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.qty"
                  @focus="$event.target.select()"
                  placeholder="Qty"
                  dense
                  outlined
                  @keypress="filter($event)"
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.measure="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.measure"
                  @focus="$event.target.select()"
                  @keypress="filter($event)"
                  :suffix="getSuffix(props.item)"
                  :disabled="!props.item.shipment_type"
                  :placeholder="props.item.shipment_type ? 'Measure' : ''"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.rate="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.rate"
                  @focus="$event.target.select()"
                  placeholder="Rate"
                  dense
                  outlined
                  @keypress="filter($event)"
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.amount="props">
                <v-text-field
                  class="right-input bg-white"
                  dense
                  :value="formatNumberAmount($numeral, computeAmount(props.item))"
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </template>


              <template v-slot:item.action="{ item }">
                <v-icon
                  color=" darken-2"
                  @click="deleteItem(item)">
                  mdi-close
                </v-icon>
              </template>

              <template v-slot:body.append>
                <tr class="sm-hidden">
                  <td class="text-right"><strong>TOTAL</strong></td>
                  <td class="text-center">
                    <strong>{{ formatNumber(totalQty) }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>{{ formatNumber(totalCbm) }}</strong>
                  </td>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <td class="text-center" colspan="6">
                    <div class="mt-4">
                          <v-btn
                            fab
                            dark
                            small
                            depressed
                            color="primary"
                            class="mb-1"
                            @click="addMoreItems()"
                          >
                            <v-icon dark>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <br>
                          <span class="primary-color font-weight-medium">Add Item</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-sheet>

          <v-row class="mt-6" v-if="extraCharges.length > 0">
            <v-col cols="12">
              <v-sheet
                rounded
                class="pa-5 px-6 pb-7"
                outlined>
                <v-card-title>
                  Storage Fee
                </v-card-title>
                <v-data-table
                  :headers="extraChargesheaders"
                  :items="extraCharges"
                  :loading="loading"
                  :items-per-page="1000"
                  hide-default-footer
                  loading-text="Loading Items..."
                  no-data-text="No Items"
                  ref="table">

                  <template v-slot:[`item.total_amount`]="{ item }">
                    {{ formatNumberAmount($numeral, item.total_amount) }}
                  </template>

                  <template v-slot:[`item.from_charge_date`]="{ item }">
                    {{ item.from_charge_date | moment("MMM D, YYYY") }}
                  </template>

                  <template v-slot:[`item.to_charge_date`]="{ item }">
                    {{ item.to_charge_date | moment("MMM D, YYYY") }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      class="mr-2"
                      color="primary"
                      small
                      depressed
                      dark
                      @click="addBill(item)"
                    >
                      <v-icon small class="mr-2">mdi-check</v-icon>
                      Bill
                    </v-btn>

                    <v-btn
                      dark
                      color="red"
                      depressed
                      small
                      @click="confirmVoidItem(item)"
                    >
                      <v-icon small class="mr-2">mdi-cancel</v-icon>
                      Void
                    </v-btn>

                  </template>
                </v-data-table>
              </v-sheet>
            </v-col>
          </v-row>


          <v-row class="mt-6">
            <v-col cols="12" sm="12" md="5">
              <v-textarea
                v-model="invoice.remarks"
                label="Remarks"
                rows="6"
                outlined
                maxlength="255"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="4" offset-md="3">
              <v-card-title class="text-caption pa-0">
                Subtotal
                <v-spacer></v-spacer>
                <span class="text-subtitle-2">{{formatNumberAmount($numeral, subTotal)}}</span>
              </v-card-title>
              <v-card-title class="text-caption pa-0 py-4">
                Discounts
                <v-spacer></v-spacer>
                <v-text-field
                    class="right-input bg-white input-footer"
                    prepend-inner-icon="mdi-minus-thick"
                    v-model="invoice.discounts"
                    @focus="$event.target.select()"
                    dense
                    outlined
                    @keypress="filter($event)"
                    hide-details
                  >
                  </v-text-field>
              </v-card-title>

              <v-card-title class="text-caption pa-0 pb-4">
                <v-checkbox
                  v-model="invoice.add_vat"
                  hide-details
                  dense
                >
                  <template v-slot:label>
                    <div class="text-subtitle-2">
                      Add VAT 12%
                    </div>
                  </template>
                </v-checkbox>
                <v-spacer></v-spacer>
                <span class="text-subtitle-2">{{formatNumberAmount($numeral, addVat)}}</span>
              </v-card-title>

              <v-card-title class="text-caption pa-0 pb-4">
                <v-checkbox
                  v-model="invoice.less_withholding_tax"
                  hide-details
                  dense
                >
                  <template v-slot:label>
                    <div class="text-subtitle-2">
                      Less Withholding Tax
                    </div>
                  </template>
                </v-checkbox>
                <v-spacer></v-spacer>
                <span class="text-subtitle-2"><strong>-</strong>{{formatNumberAmount($numeral, lessWithholdingTax)}}</span>
              </v-card-title>

              <v-card-title class="text-caption pa-0 pb-4 d-flex">
                <span class="text-subtitle-2">Points Redeemed</span>
                <v-spacer></v-spacer>
                <v-text-field
                    class="right-input bg-white input-footer"
                    prepend-inner-icon="mdi-minus-thick"
                    v-model="invoice.points_redeemed"
                    @focus="$event.target.select()"
                    placeholder="Points to redeem"
                    dense
                    outlined
                    @keypress="filter($event)"
                    hide-details
                  >
                  </v-text-field>
              </v-card-title>

              <v-card-title class="text-caption pa-0">
                Grand Total
                <v-spacer></v-spacer>
                <span class="text-subtitle-1 font-weight-bold">{{formatNumberAmount($numeral, totalAmount)}}</span>
              </v-card-title>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions class="ml-2 my-2">
          <v-btn
            color="primary mr-4"
            depressed
            large
            @click="doSave()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Save Invoice</span>
          </v-btn>

          <v-btn
            color="btn-yellow"
            depressed
            large
            v-if="invoice.status == $getConstInvoiceStatus('INVOICE_STATUS_CREATED')"
            @click="doSend()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Send Invoice</span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="forInvoiceDialog.show" persistent max-width="800px" content-class="default-dialog-container">
        <ForInvoice
          :forInvoiceDialog="forInvoiceDialog"
          @selectItem="selectItem"
          >
        </ForInvoice>
      </v-dialog>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max, numeric } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import Loader from '@/components/Loader.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import { mapGetters } from "vuex";
  import ActionButtons from '@/components/ActionButtons.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import ForInvoice from '@/components/ForInvoice.vue'
  import InvoiceStatus from '@/components/InvoiceStatus.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: 'Email must be valid',
  })

  extend('numeric', {
    ...numeric,
    message: '{_field_} should be numeric',
  })

  export default {
    name: 'InvoiceUpdate',
    props: ['id'],
    data: () => ({
      accountingNamespace: 'accounting',
      forInvoiceDialog: {
        show: false,
        selected_items: [],
        client_id: ''
      },
      menuDueDate: false,
      menuCreatedDate: false,
      loading: false,
      isLoading: false,
      awaitingSearch: false,
      deletedItems: [],
      client: null,
      search: null,
      menuEstDeliveryDate: false,
      perPage: 2000,
      print: false,
      actionBtnSettings: {
        edit: 0,
        save: 1,
        refresh: 1,
        close: 1,
        print: 0,
        send: 1,
        save_and_print: 1,
        save_disabled: false,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: false
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      invoice: {
        id: '',
        invoice_no: '',
        ref_no: '',
        bill_to_name: '',
        bill_to_contact_no: '',
        bill_to_address: '',
        invoice_date: '',
        remarks: '',
        sub_total: 0,
        discounts: 0,
        other_charges: 0,
        net_amount: 0
      },
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      statuses: [],
      subNavs: [
        {
          text: 'Invoices',
          disabled: false,
          exact: true,
          to: {
            name: 'invoices'
          },
        },
        {
          text: 'Update Invoice',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      items: [],
      extraCharges: [],
      storageFeeAppliedCharges: [],
      extraChargesheaders: [
        {
          text: 'Item',
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: 'Day(s)',
          align: 'center',
          value: 'total_excess_days',
          sortable: false,
        },
        {
          text: 'Amount',
          align: 'right',
          value: 'total_amount',
          sortable: false,
        },
        {
          text: 'From',
          align: 'center',
          value: 'from_charge_date',
          sortable: false,
        },
        {
          text: 'To',
          align: 'center',
          value: 'to_charge_date',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          align: 'center',
          sortable: false,
          width: 200
        }
      ],
      headers: [
        {
          text: 'Item',
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: 'Qty',
          align: 'center',
          value: 'qty',
          sortable: false,
          width: 120
        },
        {
          text: 'Measure',
          align: 'center',
          value: 'measure',
          sortable: false,
          width: 150
        },
        {
          text: 'Rate',
          align: 'center',
          value: 'rate',
          sortable: false,
          width: 120
        },
        {
          text: 'Amount',
          align: 'center',
          value: 'amount',
          sortable: false,
          width: 150
        },
        {
          text: '',
          value: 'action',
          align: 'center',
          sortable: false,
          width: 50
        }
      ]
    }),
    watch: {
      extraCharges: {
        handler () {
          this.invoice.other_charges = this.otherChargesAmountBilled
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'formatNumberAmountNoComma', 'getCurrentUser', 'forSea']),
      forUpdate: function(){
        return this.id ? true : false
      },
      subTotal: function(){
        let amount = 0

        this.items.forEach(obj => {
          let computedAmount = 0
          if(obj['shipment_type']){
            computedAmount = Number(this.formatNumberAmountNoComma(this.$numeral, obj['measure'])) *
              Number(this.formatNumberAmountNoComma(this.$numeral, obj['rate']))
            // if(obj['shipment_type'] == this.$getConstShipmentType('SHIPMENT_TYPE_SEA')){
            //   computedAmount = Number(this.formatNumberAmountNoComma(this.$numeral, obj['qty'])) *
            //     Number(this.formatNumberAmountNoComma(this.$numeral, obj['measure'])) *
            //     Number(this.formatNumberAmountNoComma(this.$numeral, obj['rate']))
            // } else if(obj['shipment_type'] == this.$getConstShipmentType('SHIPMENT_TYPE_AIRFREIGHT')){
            //   computedAmount = Number(this.formatNumberAmountNoComma(this.$numeral, obj['measure'])) *
            //     Number(this.formatNumberAmountNoComma(this.$numeral, obj['rate']))
            // }
          } else {
            computedAmount = Number(this.formatNumberAmountNoComma(this.$numeral, obj['qty'])) *
              Number(this.formatNumberAmountNoComma(this.$numeral, obj['rate']))
          }

          amount = amount + computedAmount
        })
        return amount
      },
      addVat: function(){
        let amount = 0
        if(this.invoice.add_vat){
          amount = Number(this.formatNumberAmountNoComma(this.$numeral, this.subTotal)) * 0.12
        }

        return amount
      },
      lessWithholdingTax: function(){
        let amount = 0
        if(this.invoice.less_withholding_tax){
          amount = Number(this.formatNumberAmountNoComma(this.$numeral, this.subTotal)) * 0.02
        }

        return amount
      },
      totalAmount: function(){
        let sub_total = Number(this.formatNumberAmountNoComma(this.$numeral, this.subTotal))
        let discounts = Number(this.formatNumberAmountNoComma(this.$numeral, this.invoice.discounts))
        let points_redeemed = Number(this.formatNumberAmountNoComma(this.$numeral, this.invoice.points_redeemed))
        return (((sub_total - discounts) + this.addVat) - this.lessWithholdingTax) - points_redeemed
      },
      totalQty: function(){
        let qty = 0

        this.items.forEach(obj => {
          qty = qty + Number(this.formatNumberAmountNoComma(this.$numeral, obj.qty))
        })
        return qty
      },
      totalCbm: function(){
        let cbm = 0
        this.items.forEach(obj => {
          cbm = cbm + Number(this.formatNumberAmountNoComma(this.$numeral, obj.measure))
        })
        return cbm
      }
    },
    methods: {
      scrollToElement (element, body) {
        this.$scrollTo(
          element,
          500,
          {
            container: body,
            easing: 'ease-in',
            lazy: false,
            offset: -100,
            force: true,
            cancelable: true,
            onStart: function(element) {
              // scrolling started
            },
            onDone: function(element) {
              // scrolling is done
            },
            onCancel: function() {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
        )
      },
      getShipmentIcon (item) {
        if(item.shipment_type){
          return this.isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane'
        }else{
          return ''
        }
      },
      getSuffix (item) {
        if(item.shipment_type){
          return this.isShipmentForSea(item.shipment_type) ? 'CBM' : 'KG'
        }else{
          return ''
        }
      },
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      showForInvoice () {
        this.forInvoiceDialog.show = true
      },
      addBill (item) {
        let added = false
        let self = this
        let i = 0
        let dayt = this.$moment(item['from_charge_date']).format('MMM D')
        let days = item['total_excess_days'] + ' day'
        if(item['from_charge_date'] != item['to_charge_date']){
          dayt = this.$moment(item['from_charge_date']).format('MMM D') + ' - ' + this.$moment(item['to_charge_date']).format('MMM D')
        }

        if(item['total_excess_days'] > 1){
          days =+ 's'
        }

        this.items.forEach(obj => {
          if(obj.description.trim().length == 0 && obj.qty.trim().length == 0 &&
            obj.measure.trim().length == 0 && obj.rate.trim() == 0){
              if(!added){
                obj.booking_detail_id = item['booking_detail_id']
                obj.description = item['description'] + ' - ' + days
                obj.storage_description = item['description']
                obj.billed = item['billed']
                obj.invoice_id = item['invoice_id']
                obj.from_charge_date = item['from_charge_date']
                obj.to_charge_date = item['to_charge_date']
                obj.total_amount = item['total_amount']
                obj.total_excess_days = item['total_excess_days']
                obj.qty = 1
                obj.measure = 1
                obj.rate = item['total_amount']
                obj.trans_type = '1'
                added = true
              }
          }
        })

        if(!added){
          this.items.push(
            {
              booking_detail_id: item['booking_detail_id'],
              description: item['description'] + ' - ' + dayt,
              storage_description: item['description'],
              billed: item['billed'],
              invoice_id: item['invoice_id'],
              from_charge_date: item['from_charge_date'],
              to_charge_date: item['to_charge_date'],
              total_amount: item['total_amount'],
              total_excess_days: item['total_excess_days'],
              qty: 1,
              measure: 1,
              rate: item['total_amount'],
              trans_type: '1'
            }
          )
        }

        this.extraCharges.splice(this.extraCharges.indexOf(item), 1)
      },
      selectItem (selectedItems) {
        let self = this
        selectedItems.forEach(obj => {
          self.items.unshift(
            {
              booking_detail_id: obj['id'],
              description: obj['shipping_mark'] + ' - ' +obj['item_description'],
              shipment_type: obj['shipment_type'],
              qty: obj['qty'],
              measure: this.isShipmentForSea(obj['shipment_type']) ? obj['cbm'] : obj['kg'],
              rate: obj['rate']
            }
          )

          this.forInvoiceDialog.selected_items.push(obj['id'])
        })

      },
      computeAmount (item){
        let amount = 0

        if(item.shipment_type){
          amount = Number(this.formatNumberAmountNoComma(this.$numeral, item.measure)) *
            Number(this.formatNumberAmountNoComma(this.$numeral, item.rate))
          // if(item.shipment_type == this.$getConstShipmentType('SHIPMENT_TYPE_SEA')){
          //   amount = Number(this.formatNumberAmountNoComma(this.$numeral, item.qty)) *
          //     Number(this.formatNumberAmountNoComma(this.$numeral, item.measure)) *
          //     Number(this.formatNumberAmountNoComma(this.$numeral, item.rate))
          // } else if(item.shipment_type == this.$getConstShipmentType('SHIPMENT_TYPE_AIRFREIGHT')){
          //   amount = Number(this.formatNumberAmountNoComma(this.$numeral, item.measure)) *
          //     Number(this.formatNumberAmountNoComma(this.$numeral, item.rate))
          // }
        } else {
          amount = Number(this.formatNumberAmountNoComma(this.$numeral, item.qty)) *
            Number(this.formatNumberAmountNoComma(this.$numeral, item.rate))
        }

        return amount
      },
      doClose (){
        this.cancelInvoice()
      },
      doSend (){
        self.loading = true
        this.alerMessage.show = false
        this.$http.secured.post(this.accountingNamespace+'/invoices/send/'+this.id, '')
          .then(response => {
            this.getInvoice()
            this.showMessage("Invoice "+this.invoice.invoice_no+" has been successfully sent", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      cancelInvoice() {
        this.dialog = {
          show: true,
          title: 'Close Invoice',
          body: 'Are you sure you want to close this invoice?',
          type: 'close',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doRefresh (){
        this.getInvoice()
      },
      doSavePrint (){
        this.print = true
        this.doSave()
      },
      doConfirm () {
        this.dialog.show = false

        if(this.dialog.type == 'close'){
          this.$router.push({ name: 'invoices' })
        }else if(this.dialog.type == 'void-storage-fee'){
          this.voidItem()
        }else{
          if(Object.prototype.hasOwnProperty.call(this.dialog.item, "booking_detail_id")){
            if(Object.prototype.hasOwnProperty.call(this.dialog.item, "id")){
              this.deletedItems.push(this.dialog.item.id)
            }
            this.forInvoiceDialog.selected_items.splice(this.forInvoiceDialog.selected_items.indexOf(this.dialog.item.booking_detail_id), 1)
          }else{
            this.forInvoiceDialog.selected_items.splice(this.forInvoiceDialog.selected_items.indexOf(this.dialog.item.id), 1)
          }

          this.items.splice(this.items.indexOf(this.dialog.item), 1)

          if(this.dialog.item.description.length > 0){
            this.showMessage(this.dialog.item.description + " has been successfully deleted", 'success')
          }

          if(Object.prototype.hasOwnProperty.call(this.dialog.item, "storage_description")){
            if(this.dialog.item.trans_type == '1'){
              this.extraCharges.push({
                booking_detail_id: this.dialog.item.booking_detail_id,
                description: this.dialog.item.storage_description,
                billed: this.dialog.item.billed,
                invoice_id: this.dialog.item.invoice_id,
                from_charge_date: this.dialog.item.from_charge_date,
                to_charge_date: this.dialog.item.to_charge_date,
                total_amount: this.dialog.item.total_amount,
                total_excess_days: this.dialog.item.total_excess_days
              })
            }
          }

        }
      },
      confirmVoidItem (item){
        this.dialog = {
          show: true,
          title: 'Void Storage Fee',
          body: 'Are you sure you want to void storage fee for '+item.description+'?',
          type: 'void-storage-fee',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      voidItem (){
        let data = {
          booking_detail_id: this.dialog.item.booking_detail_id,
          description: this.dialog.item.description
        }
        this.$http.secured.post(this.accountingNamespace+'/extra-charges/void', data)
          .then(response => {
            this.extraCharges.splice(this.extraCharges.indexOf(this.dialog.item), 1)
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
          })
      },
      doCancel () {
        this.dialog.show = false
      },
      getExtraCharges () {
        let params = []
        let self = this
        this.$http.plain.get(this.accountingNamespace+'/extra-charges/'+this.invoice.bill_to)
          .then(response => {
            this.extraCharges = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
          })
      },
      deleteItem (item) {
        if(item.description.length == 0){
          this.items.splice(this.items.indexOf(item), 1)
          return false
        }
        this.dialog = {
          show: true,
          title: 'Delete Item',
          body: 'Are you sure you want to delete '+item.description+' item?',
          type: 'item',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      addMoreItems(){
        this.items.push(
          { description: '', qty: '', measure: '', rate: '', amount: ''}
        )
      },
      generateItemRows() {
        // for (let i = 0; i < 1; i++) {
        //   this.items.push(
        //     { description: '', qty: '', measure: '', rate: '', amount: ''}
        //   )
        // }
      },
      getInvoice () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.accountingNamespace+'/invoices/'+this.id)
          .then(response => {
            this.invoice = response.data
            this.items = this.invoice.items
            this.forInvoiceDialog.client_id = this.invoice.bill_to
            this.forInvoiceDialog.selected_items = []
            this.deletedItems = []
            this.items.forEach(obj => {
              if(Object.prototype.hasOwnProperty.call(obj, "booking_detail_id")){
                if(obj['trans_type'] == '0'){
                  this.forInvoiceDialog.selected_items.push(obj['booking_detail_id'])
                }
              }
            })

            this.generateItemRows()
            this.getExtraCharges()
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?invoice_statuses=true')
          .then(response => {
            this.statuses = response.data.invoice_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      update () {
        if (this.invoice.points_redeemed < 0) {
          this.showMessage("Invalid redeeming points.", 'error')
          this.loading = false
          return
        }

        this.loading = true
        let self = this

        let data = {
          bill_to_name: this.invoice.bill_to_name,
          bill_to_contact_no: this.invoice.bill_to_contact_no,
          bill_to_address: this.invoice.bill_to_address,
          ref_no: this.invoice.ref_no,
          invoice_date: this.invoice.invoice_date,
          due_date: this.invoice.due_date,
          remarks: this.invoice.remarks,
          discounts: this.invoice.discounts,
          other_charges: this.invoice.other_charges,
          items: this.items,
          deleted_items: this.deletedItems,
          less_withholding_tax: this.invoice.less_withholding_tax,
          add_vat: this.invoice.add_vat,
          points_redeemed: this.invoice.points_redeemed
        }

        this.$http.secured.put(this.accountingNamespace+'/invoices/'+this.id, data)
          .then(response => {
            this.getInvoice()
            this.showMessage(this.invoice.invoice_no + " has been successfully updated", 'success')

            if(this.print){
              const currentDate = new Date();
              const unixTimestamp = Math.floor(currentDate.getTime() / 1000)

              this.print = false
              window.open('/api/'+this.accountingNamespace+'/invoices/'+this.id+'?print=true&v='+unixTimestamp, '_newtab');
            }
          })
          .catch(error => {
            this.getExtraCharges()
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            this.scrollToElement('body', 'body')
          })
          .then(function () {
            self.loading = false
          })
      },
      async doSave () {
        this.alerMessage.show = false

        if(this.loading){
          return false;
        }

        this.loading = true
        this.update()
      },
      clear () {
        Object.keys(this.invoice).forEach(key => {
          this.invoice[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getInvoice()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.getDefaultData()
      this.getInvoice()
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      Loader,
      ActionButtons,
      AlertMessage,
      ForInvoice,
      InvoiceStatus
    }
  }
</script>
